import { render, staticRenderFns } from "./nftAppeal.vue?vue&type=template&id=6f91df3e&scoped=true"
import script from "./nftAppeal.vue?vue&type=script&lang=js"
export * from "./nftAppeal.vue?vue&type=script&lang=js"
import style0 from "./nftAppeal.vue?vue&type=style&index=0&id=6f91df3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f91df3e",
  null
  
)

export default component.exports